export default function InfoRow({
  label,
  value,
  children,
  className = "",
  labelClassName = "",
  valueClassName = "",
}) {
  return (
    <div className={`mb-4 ${className}`}>
      <dt className={`text-sm font-semibold text-text mb-1 ${labelClassName}`}>
        {label}
      </dt>
      <dd className={`text-sm text-text opacity-80 ${valueClassName}`}>
        {children || value || (
          <span className="italic opacity-50">Not provided</span>
        )}
      </dd>
    </div>
  );
}
